import { TextField } from '@mui/material'
import React from 'react'

import { SUBSCRIPTION_ID_FIELD_PROPS } from 'components/common/mapped-entities/azure/authentication/azure-auth-form-utils'
import { AzureAuthenticationSection } from 'components/common/mapped-entities/azure/authentication/AzureAuthenticationSection'
import { ViewOnlyAlert } from 'components/common/mapped-entities/ViewOnlyAlert'
import { type TeamExternalIntegration } from 'types/api/status-checks/status-check'

export function AzureAuthenticationSectionReadOnly({
  selectedIntegration
}: {
  selectedIntegration: TeamExternalIntegration
}) {
  return (
    <>
      <ViewOnlyAlert />
      <AzureAuthenticationSection isReadOnly templateUrl="">
        <TextField
          {...SUBSCRIPTION_ID_FIELD_PROPS}
          disabled
          value={selectedIntegration.domain ?? ''}
        />
      </AzureAuthenticationSection>
    </>
  )
}
